import { FC, ReactNode } from 'react';
import { Tr } from '@utils';
import { Button, ButtonProps, Stack, StackProps, Typography } from '@mui/material';

export interface IEmptyEntityPageLayoutProps extends Omit<StackProps, 'title'> {
	illustration?: ReactNode;
	title?: ReactNode;
	content?: ReactNode;
	addButtonText?: ReactNode;
	addButtonProps?: Extendable<Omit<ButtonProps, 'onClick' | 'children'>>;
	onAddButtonClick?: () => void;
}

export const EmptyEntityPageLayout: FC<IEmptyEntityPageLayoutProps> = ({
	illustration,
	title,
	content,
	addButtonText,
	addButtonProps,
	onAddButtonClick,
	sx,
	...props
}) => {
	return (
		<Stack
			direction="column"
			alignItems="center"
			justifyContent="center"
			spacing={3}
			sx={{ height: 1.0, maxWidth: 600, marginX: 'auto !important', ...sx }}
			{...props}
		>
			{illustration}
			<Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
				{title && (
					<Typography variant="h3" fontWeight={600} textAlign="center">
						{title}
					</Typography>
				)}
				{content || <Typography textAlign="center">{<Tr.Portal path="no-entity-content" />}</Typography>}
			</Stack>
			{addButtonText && (
				<Button data-testid="add-entity-button" variant="contained" onClick={onAddButtonClick} {...addButtonProps}>
					{addButtonText}
				</Button>
			)}
		</Stack>
	);
};
